// valid UUID v4
const regex_uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i

// digits only (0...9)
const regex_digits = /^\d+$/

// english letters, numbers without space, allowing '-' and '_'
const regex_code = /^[a-zA-Z0-9_-]+$/

// valid url (http:// or https://)
const regex_url = /^(http|https):\/\/.+$/

// ipv4 (mask allowed)
const regex_ipv4 = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[1-2]?[0-9])$|^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

export {
  regex_uuid,
  regex_digits,
  regex_code,
  regex_url,
  regex_ipv4
}
